import { useNavigate            }   from "react-router-dom";
import    React,
        { useEffect, 
          useState              }   from "react";
import { InputGeneral, 
         InputPassword          }   from "components/Field/field";
import { BtnCloseAction         }   from "components/Buttons/Close/BtnClose";
import { login, 
         msLogin, 
         getRecoveryCode, 
         getNewPass, 
         validateEmailData      }   from "./homeService";
import { QuantumDrive           }   from "Utilities/utils";
import { useLoader, 
         LoaderCover            }   from "components/Covers/loadingCover";
import { useModal, Modal        }   from "components/Covers/genericModal";
import { DefaultLoadingLogo, 
         GetSystemLabel         }   from "Utilities/utils";
import LogoImage                   from "../../assets/logo512.png";

import Style from "components/UI/main.module.scss";

const ModalContent         = React.memo(({...Content}) => {    
    const {Message, ClickAction} = Content;
    return (
        <div>
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                    <div className={[Style.p_5].join(" ")}>
                        <span className={[Style.text_body, Style.fs_8].join(" ")}>
                            {Message}
                        </span>
                    </div>
                </div>
            </div>        
        </div>
    );
});

const AutoLoginHandler      = () => {
    const { showLoader, hideLoader           }  = useLoader();
    const { showModal                        }  = useModal();
    const navigate                              = useNavigate();
    
    async function handleMsLogin(code) {
        try {
            let payload = await msLogin(code);
            if (payload) {
                hideLoader();
                if (payload?.Status?.Code === 0) {
                    QuantumDrive(payload?.Response);
                    sessionStorage.removeItem("MSLogin");
                    navigate("/home");
                } 
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                    sessionStorage.removeItem("MSLogin");
                }
            } 
            else {
                showModal(<ModalContent Message={GetSystemLabel("AutoLoginError")}/>);
                sessionStorage.removeItem("MSLogin");
            }
        } 
        catch (error) {
            console.error(error);
        }
    };
  
    useEffect(() => {
      try {
          if (localStorage.getItem("Tolkien")){
            navigate("/home");
          }
          else if (sessionStorage.getItem("MSLogin")) {
              let search = window.location.search;
              if (search.length > 0){
                  search = search.split("&");
                  let code = search[0].split("code=");
                  if (code && (code.length > 0)) {
                      showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetSystemLabel("Loading")});
                      handleMsLogin(code[1]);
                  }
              }            
          }
      } 
      catch (e) {
          console.error(e);
      }
    }, []);
  
    return null;
};
const BtnLogin              = ({data}) => {
    const { showLoader, hideLoader           }  = useLoader();
    const { showModal                        }  = useModal();
    const navigate                              = useNavigate();

    const handleLogin = async () => {
        try {
            if ((data.email != "") && (data.password != "")) {
                let isValid = validateEmailData(data.email);
                if (isValid) {
                    showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetSystemLabel("Loading")});
                    let payload = await login(data.email, data.password);
                    if (payload) {
                        hideLoader();
                        if (payload.Status.Code == 0) {
                            QuantumDrive(payload.Response);
                            navigate("/home");
                        }
                        else {
                            showModal(<ModalContent Message={payload.Status.Message}/>);
                        }                        
                    }
                }
                else {
                    showModal(<ModalContent Message={GetSystemLabel("InvalidCredentials")}/>);
                }
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("InvalidCredentials")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    
    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === "Enter") {
                handleLogin();
            }
        };
        document.addEventListener("keypress", handleKeyPress);
        return () => {
            document.removeEventListener("keypress", handleKeyPress);
        };
    }, [data]);

    return (
        <>
            <div
                className={[Style.clickable,
                            Style.primary_bg, 
                            Style.rounded_3, 
                            Style.border, 
                            Style.shadow_sm, 
                            Style.fs_6,
                            Style.text_white,
                            Style.py_3,
                            Style.px_5,
                            Style.pop_item_animation].join(" ")}
                onClick={handleLogin}
            >
                {GetSystemLabel("Enter")}
            </div>
        </>
    );
};
const BtnLoginMicrososft    = () => {
    const handleMicrosoftLogin = () => {
        sessionStorage.setItem("MSLogin", "started"); 
        let location = `https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?client_id=b5c0c798-5eb3-476e-a7d6-870398c6ff34&response_type=code&redirect_uri=${process.env.REACT_APP_BASE_URL}&scope=openid%20profile%20User.Read`;
        window.location.href = location;
    };

    useEffect(() => {
      }, [handleMicrosoftLogin]);


    return (
        <>
            <div    className={[Style.clickable,
                                Style.primary_bg, 
                                Style.rounded_3, 
                                Style.border, 
                                Style.shadow_sm, 
                                Style.fs_6,
                                Style.text_white,
                                Style.py_3,
                                Style.px_5,
                                Style.pop_item_animation].join(" ")}
                    onClick={handleMicrosoftLogin}
            >
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                    <div className={[Style.align_middle].join(" ")}>
                        <img className={[Style.icoMicrosoft].join(" ")}/>
                    </div>
                    <div className={[Style.text_white, Style.fs_6, Style.text_start, Style.m_2].join(" ")}>
                        <span>{GetSystemLabel("MicrosoftLogin")}</span>
                    </div>
                </div>
            </div>
        </>
    );

};
const DefaultPadding        = () => {
    return(<div className={[Style.py_2].join(" ")}/>);
};
export const HomePage       = () => {
    const [modalType , setModalType]        = useState(1);
    const [email, setEmail]                 = useState("");
    const [password, setPassword]           = useState("");
    const [recoveryCode, setRecoveryCode]   = useState("");
    const { showLoader, hideLoader }        = useLoader();
    const { showModal}                      = useModal();    

    const handleRecoveryAction = async () => {
        try {
            if ((email != "")) {
                let isValid = validateEmailData(email);
                if (isValid) {
                    showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetSystemLabel("Loading")});
                    let payload = await getRecoveryCode(email);
                    if (payload) {
                        hideLoader();
                        if (payload.Status.Code == 0) {
                            modalControl(3);
                            showModal(<ModalContent Message={GetSystemLabel("RecoveryCodeCheckPostalCode").replace("$placeholder", email)}/>);
                        }
                        else {
                            showModal(<ModalContent Message={payload.Status.Message}/>);
                        }                        
                    }
                }
                else {
                    showModal(<ModalContent Message={GetSystemLabel("EmailInvalid")}/>);
                }
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("EmailInvalid")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    const modalControl = (itype) => {
        setModalType(itype);
    };

    const BtnGetRecoveryPassWord = ({data}) => {
        const { showLoader, hideLoader }            = useLoader();
        const {showModal}                           = useModal();
    
        const handleAction = async () => {
            try {
                if ((data.recoveryCode != "")) {
                    if ((data.recoveryCode.length) > 10 ) {
                        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage:  GetSystemLabel("Loading")});
                        let payload = await getNewPass(data.recoveryCode);
                        if (payload) {
                            hideLoader();
                            if (payload.Status.Code == 0) {
                                modalControl(1);
                                showModal(<ModalContent Message={GetSystemLabel("PasswordCheckPostalCode").replace("$placeholder", email)}/>);
                            }
                            else {
                                showModal(<ModalContent Message={payload.Status.Message}/>);
                            }                        
                        }
                    }
                    else {
                        showModal(<ModalContent Message={GetSystemLabel("RecoveryCodeInvalid")}/>);
                    }
                }
                else {
                    showModal(<ModalContent Message={GetSystemLabel("RecoveryCodeInvalid")}/>);
                }
            }
            catch (error) {
                console.error(error);
            }
        };
    
        return (
            <div    className={[Style.clickable,
                                Style.pop_item_animation].join(" ")}
                onClick={handleAction}
            >
                <span className={[Style.text_body, Style.fs_8, Style.text_decoration_underline].join(" ")}>
                    {GetSystemLabel("RecoveryCodeEnterWith")}
                </span>
            </div>
        );
    };

    useEffect(() => {        
    },[modalType, email, password, recoveryCode]);

    return (
        <>
            <LoaderCover/>
            <Modal/>
            <AutoLoginHandler/>
            <div className={Style.row}>
                <div style={{display: 'none'}} className={[Style.col_lg, Style.d_lg_inline].join(" ")}>
                    <div style={{backgroundColor: "#003A6F"}}>
                        <div style={{height: '100vh', width: '100%' }} className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                            <img 
                                src={LogoImage}
                                style={{    width: '30%',    
                                            height: 'auto',   
                                            maxWidth: '60%',  
                                            minWidth: '20%'   
                                }}
                                alt="Logo ISE"
                            />
                            <p className={[Style.text_white, Style.fs_1, Style.fw_bold].join(" ")}>
                                ISEFeedBack
                            </p>
                        </div>
                    </div>
                </div>
                {
                    modalType == 1 ?
                        <div className={Style.col_lg}>
                            <div style={{height: '100vh', width: '100%' }} className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                                <div className={[Style.container].join(" ")}>
                                    <div className={Style.mx_3}>
                                        <DefaultPadding/>
                                        {/* Login Microsoft*/}
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                <div className={[Style.d_flex, Style.text_start].join(" ")}>
                                                    <span className={[Style.fs_8, Style.text_body].join(" ")}>{GetSystemLabel("LoginLabelHeader")}</span>
                                                </div>
                                                <div className={[Style.border_bottom, Style.my_3].join(" ")}/>
                                                
                                                <BtnLoginMicrososft/>


                                            </div>
                                        </div>
                                        <DefaultPadding/>
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                <span className={[Style.fs_8,
                                                                Style.text_color].join(" ")}>
                                                                    {GetSystemLabel("Email")}:
                                                </span>
                                                <InputGeneral 
                                                    value={email}
                                                    className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                                    onChange={(event) => setEmail(event.target.value)}
                                                    placeholder={GetSystemLabel("FillWith") + GetSystemLabel("email")}
                                                    maxLength={320}
                                                /> 
                                            </div>
                                        </div>
                                        <DefaultPadding/>
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                <span className={[Style.fs_8,
                                                                Style.text_color].join(" ")}>
                                                                    {GetSystemLabel("Password")}:
                                                </span>
                                                <InputPassword 
                                                    value={password}
                                                    type={"password"}
                                                    className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                                    onChange={(event) => setPassword(event.target.value)}
                                                    placeholder={GetSystemLabel("FillWith") + GetSystemLabel("password")}
                                                    icon_style={Style.btnEyePassword}
                                                    icon_style_hover={Style.btnEyePasswordHover}
                                                />
                                            </div>
                                        </div>
                                        <DefaultPadding/>
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                <div className={[Style.text_end].join(" ")}>
                                                    <span className={[Style.fs_8,
                                                                    Style.text_color, 
                                                                    Style.text_decoration_underline,
                                                                    Style.text_clickable].join(" ")}
                                                        onClick={() => {modalControl(2);}}
                                                    >
                                                        {GetSystemLabel("PasswordForgot")}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <DefaultPadding/>                    
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                <div className={Style.text_center}>
                                                    <BtnLogin data={{email, password}}/>
                                                </div>
                                            </div>
                                        </div>
                                        <DefaultPadding/>
                                        <DefaultPadding/>
                                    </div>
                                </div>
                            </div>
                        </div>                  
                    : modalType == 2 ?
                        <div className={Style.col_lg_6}>
                            <div style={{height: '100vh', width: '100%' }} className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                                <div className={[Style.container].join(" ")}>
                                    <div className={Style.mx_3}>
                                        <DefaultPadding/>
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                <div className={[Style.text_end].join(" ")}>
                                                    <BtnCloseAction click_action={() => {modalControl(1);}}/>
                                                </div>
                                            </div>
                                        </div>
                                        <DefaultPadding/>
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                    <span className={[Style.fs_8,
                                                                    Style.text_color].join(" ")}>
                                                        {GetSystemLabel("RecoveryCodeLabelHeader")}
                                                    </span>
                                                    <InputGeneral 
                                                        value={email}
                                                        className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                                        onChange={(event) => setEmail(event.target.value)}
                                                        placeholder={GetSystemLabel("FillWith") + GetSystemLabel("email")}
                                                        maxLength={320}
                                                    />
                                            </div>
                                        </div>
                                        <DefaultPadding/>
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                <div className={[Style.clickable,Style.pop_item_animation].join(" ")} onClick={handleRecoveryAction}>
                                                    <span className={[Style.text_body, Style.fs_8, Style.text_decoration_underline].join(" ")}>
                                                        {GetSystemLabel("RecoveryCodeAskfor")}
                                                    </span>
                                                </div>
                                                <DefaultPadding/>
                                                <div className={[Style.clickable,Style.pop_item_animation].join(" ")}  onClick={()=> {setModalType(3);}}>
                                                    <span className={[Style.text_body, Style.fs_8, Style.text_decoration_underline].join(" ")}>
                                                        {GetSystemLabel("RecoveryCodeEnterWith")}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <DefaultPadding/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    : modalType == 3 ?
                        <div className={Style.col_lg}>
                            <div style={{height: '100vh', width: '100%' }} className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                                <div className={[Style.container].join(" ")}>
                                    <div className={Style.mx_3}>
                                        <DefaultPadding/>
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                <div className={[Style.text_end].join(" ")}>
                                                    <BtnCloseAction click_action={() => {modalControl(1);}}/>
                                                </div>
                                            </div>
                                        </div>                                    
                                        <DefaultPadding/>
                                        <div className={Style.row}>
                                            <div className={Style.col_lg_}>
                                                <span className={[Style.fs_8,
                                                                Style.text_color].join(" ")}>
                                                    {GetSystemLabel("RecoveryCodeHeaderAskFor")}
                                                </span>
                                                <InputGeneral 
                                                    value={recoveryCode}
                                                    className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                                    onChange={(event) => setRecoveryCode(event.target.value)}
                                                    placeholder={GetSystemLabel("FillWith") + GetSystemLabel("recoveryCode")}
                                                    maxLength={30}
                                                />
                                            </div>
                                        </div>
                                        <DefaultPadding/>
                                        <div className={Style.row}>
                                            <div className={Style.col_lg}>
                                                <BtnGetRecoveryPassWord data={{recoveryCode}}/>
                                            </div>
                                        </div>
                                        <DefaultPadding/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    : null
                }
            </div>
        </>
    );
};